<template>
  <div>
    <v-text-field
      prepend-icon="mdi-minus"
      append-outer-icon="mdi-plus"
      :value="intValue"
      hide-details
      :disabled="disable"
      @click:prepend="decrement"
      @click:append-outer="add"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 1,
    },
    disable: Boolean,
  },

  data: () => ({
    intValue: 1,
  }),

  watch: {
    value: function (newVal) {
      this.intValue = newVal;
    },
  },

  created() {
    this.intValue = this.value;
  },

  methods: {
    decrement() {
      if (this.intValue > 1) {
        this.intValue--;
        this.$emit("input", this.intValue);
      }

      // if (this.intValue < 1) {
      //   this.intValue = 1;
      // }
    },

    add() {
      this.intValue++;
      this.$emit("input", this.intValue);
    },
  },
};
</script>
